import { useEffect, useRef } from 'react';
import { Box, CircularProgress } from '@mui/material';
import PasswordResetRequest from '../login/PasswordResetRequest';
import { useSession } from '../../contexts/session-context';
import { postLoginDestination } from '../login/post-login-destination';

export default function HubPasswordResetPage() {
    const { authorize, status, isAuthenticated, user } = useSession();
    const redirected = useRef(false);

    useEffect(() => {
        // Only check the session once. After a client-side navigation between hub pages it is
        // already resolved, and re-running `authorize` would flip `status` back to 'loading' and
        // swap the whole page for the bare spinner (a white flash).
        if (status !== 'idle') return;
        authorize();
    }, [authorize, status]);

    useEffect(() => {
        if (!isAuthenticated || redirected.current) return;
        redirected.current = true;
        // ROBO-482: a visitor who already holds a session has nothing to reset — send them on as
        // sign-in would, not to a hard-coded STUDIO_HOME. So a suspended business's Owner who opens
        // the forgot-password page lands on billing, and a client lands on legacy, exactly as
        // `hub-login-page.tsx` sends them. A refused authorize never gets here: it leaves `status`
        // unauthenticated and the reset form below renders.
        window.location.replace(postLoginDestination(user));
    }, [isAuthenticated, user]);

    if (status === 'loading' || status === 'idle' || isAuthenticated) {
        return (
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{ height: '100vh', width: '100vw', overflow: 'hidden' }}
            >
                <CircularProgress color="inherit" size={32} sx={{ opacity: 0.25 }} />
            </Box>
        );
    }

    return <PasswordResetRequest />;
}
